import { render, staticRenderFns } from "./MhDevInfos.vue?vue&type=template&id=4d2f144c&scoped=true&"
import script from "./MhDevInfos.vue?vue&type=script&lang=js&"
export * from "./MhDevInfos.vue?vue&type=script&lang=js&"
import style0 from "./MhDevInfos.vue?vue&type=style&index=0&id=4d2f144c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f144c",
  null
  
)

export default component.exports